var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcInputField',_vm._g(_vm._b({ref:"inputField",attrs:{"type":"color","show-trailing-button":false},on:{"input":_vm.handleInput}},'NcInputField',{..._vm.$attrs, ..._vm.$props },false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }